import React, { useEffect } from 'react';
// import './RecipeListComponent.css'; // Removed import
import axios from 'axios';

const storeRecipesToDB = async (title, ingredients, instructions) => {
  // This function is currently causing errors because the DB doesn't exist.
  // Commenting out the actual call for now.
  /*
  try {
    const timestamp = new Date().toISOString();
    await axios.post('/recipes', { title, ingredients, instructions, timestamp });
  } catch (error) {
    // console.error('Error posting data: ', error);
  }
  */
};

const safeTitle = (title) => {
    if (typeof title === 'string') {
      return title.replace(/,+\s*$/, '');
    }
    // Handle cases where title is not a string (could log or handle differently based on needs)
    console.error('Expected title to be a string, but received:', typeof title);
    return ''; // Return a fallback string or handle as needed
  };

const safeParseJson = (data) => {
  try {
    return JSON.parse(data);
  } catch {
    return [];
  }
};

const RecipeListComponent = ({ llamaRecipes, isLoading, loadingMessage }) => {
  useEffect(() => {
    // Commenting out the call to store recipes to DB
    /*
    if (llamaRecipes) {
      llamaRecipes.forEach(recipe => storeRecipesToDB(recipe.Title, recipe.Ingredients, recipe.Instructions));
    }
    */
  }, [llamaRecipes]);

  // console.log('llamaRecipes in RecipeListComponent', llamaRecipes);

  // Function to generate JSON-LD script content for a recipe
  const generateRecipeSchema = (recipe) => {
    // Basic check for necessary properties
    if (!recipe || !recipe.Title || !recipe.Ingredients || !recipe.Instructions) {
      return null;
    }
    
    // Clean up instructions for schema (remove numbering if still present in data somehow)
    const cleanInstructions = recipe.Instructions.map(step => (
      {
        "@type": "HowToStep",
        "text": step.replace(/^\d+\.\s*/, '')
      }
    ));

    return {
      "@context": "https://schema.org/",
      "@type": "Recipe",
      "name": safeTitle(recipe.Title), // Use the safe title function
      "recipeIngredient": recipe.Ingredients, // Assumes Ingredients is an array of strings
      "recipeInstructions": cleanInstructions,
      // Optional but recommended properties:
      // "description": "A brief description of the recipe",
      // "image": "URL_to_an_image_of_the_recipe.jpg", 
      // "author": {
      //   "@type": "Person",
      //   "name": "FeastFinder AI"
      // },
      // "prepTime": "PT5M", // Example: 5 minutes preparation time (ISO 8601 duration format)
      // "cookTime": "PT15M", // Example: 15 minutes cook time
      // "totalTime": "PT20M",
      // "keywords": "ai generated, easy recipe, quick meal", // Add relevant keywords
      // "recipeYield": "1 serving",
      // "recipeCategory": "Main course",
      // "nutrition": { // Example, if you had nutrition info
      //   "@type": "NutritionInformation",
      //   "calories": "250 calories"
      // }
    };
  };

  return (
    <div className="recipe-list">
      {llamaRecipes?.map((recipe, index) => {
        const schemaData = generateRecipeSchema(recipe);
        return (
          <div key={index} className="recipe-card">
            {/* Add JSON-LD script tag if schemaData is generated */}
            {schemaData && (
              <script type="application/ld+json">
                {JSON.stringify(schemaData)}
              </script>
            )}

            <h2 className="recipe-title">{safeTitle(recipe.Title)}</h2>
            <h3>Ingredients:</h3>
            <ul>
              {(Array.isArray(recipe.Ingredients) ? recipe.Ingredients : safeParseJson(recipe.Ingredients)).map((ingredient, i) => (
                <li key={i}>{ingredient}</li>
              ))}
            </ul>
            <h3>Instructions:</h3>
            <ol>
              {(Array.isArray(recipe.Instructions) ? recipe.Instructions : safeParseJson(recipe.Instructions)).map((instruction, i) => {
                const instructionText = instruction.replace(/^\d+\.\s*/, '');
                return <li key={i}>{instructionText}</li>;
              })}
            </ol>
          </div>
        );
      })}
      {isLoading && (
        <div className="loading-container">
          <p className="loading-message">{loadingMessage || "Loading..."}</p>
          <div className="loading-spinner"></div>
        </div>
      )}
    </div>
  );
};

export default RecipeListComponent;
